class LocalizeByZipCodeError extends Error {
  constructor(message = 'Unknown zip code localization error') {
    super(message);
    this.name = "LocalizeByZipCodeError";
    this.message = message;
  }
}

export default LocalizeByZipCodeError;